module.exports = __webpack_public_path__ + "static/media/feedback_banner.5bb69cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feedback_banner.png
// module id = 1435
// module chunks = 8